import Linkify from 'linkify-react';

const options = {
  target: '_blank',
  rel: 'noopener noreferrer',
  className: 'underline text-blue-600',
};

export default function Description({ children } : { children: React.ReactNode }) {
  return <div className="break-words break-all whitespace-normal"><Linkify options={options}>{children}</Linkify></div>;
}
